<h4 mat-dialog-title></h4>

<mat-dialog-content>
    <sales-cycle-checklist [opportunitySalesCycleMap]="data.opportunitySalesCycleMap" [customerActionId]="data.customerActionId">Loading</sales-cycle-checklist>
</mat-dialog-content>

<mat-dialog-actions>
    <button class="epi-button float-right" (click)="cancel()">Close</button>
</mat-dialog-actions>
